import { useCallback, useState } from 'react'

// eslint-disable-next-line no-unused-vars
import { IData } from '../interfaces/table'

export const useSearch = () => {
  const [search, setSearch] = useState('')

  const isSearching = useCallback(() => {
    return !!search
  }, [search])

  const filter = useCallback(
    (data: IData, search: string, currentColumns: string[]) => {
      const filteredData = data.filter((item) => {
        let response = false

        currentColumns.forEach((column) => {
          const columnData = item[column]

          if (
            typeof columnData === 'string' &&
            columnData.toLocaleLowerCase().includes(search.toLocaleLowerCase())
          ) {
            response = true
          }
        })

        return response
      })

      return filteredData
    },
    []
  )

  return { search, setSearch, isSearching, filter }
}
